import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../components/AuthComponent/login";
import RegisterPage from "../components/AuthComponent/register";
import ForgotPasswordPage from "../components/AuthComponent/forgotPassword";
import ResetPasswordPage from "../components/AuthComponent/resetPassword";
import Dashboard from "../components/DashboardComponent/dashboard";
import ChatBot from "../components/ChatbotComponent/ChatBot";
import { ViewProvider } from "../utils/PersonalViewProvider";
import { WorkspaceProvider } from "../utils/WorkspaceContext";
import { AssigneeProvider } from "../utils/AssigneeContext";
import { CustomViewsProvider } from "../utils/CustomViewsProvider";

// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("accessToken");
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:uidb64/:token" element={<ResetPasswordPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <WorkspaceProvider>
              <AssigneeProvider>
                <ViewProvider>
                  <CustomViewsProvider>
                    <Dashboard />
                    <ChatBot />
                  </CustomViewsProvider>
                </ViewProvider>
              </AssigneeProvider>
            </WorkspaceProvider>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
